import * as fromDatatype from "../datatype-library/index";

export interface bl_url_hyperlink_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  url_shortened: fromDatatype.VarcharDatatypeInterface;
  url_destination: fromDatatype.VarcharDatatypeInterface;
  utm_source: fromDatatype.VarcharDatatypeInterface;
  utm_medium: fromDatatype.VarcharDatatypeInterface;
  utm_term: fromDatatype.VarcharDatatypeInterface;
  utm_content: fromDatatype.VarcharDatatypeInterface;
  click_no_total: fromDatatype.IntegerDatatypeInterface;
  click_no_unique: fromDatatype.IntegerDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
}

export class bl_url_hyperlink_hdr_RowClass implements bl_url_hyperlink_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  campaign_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  url_key: fromDatatype.VarcharDatatypeInterface;
  url_shortened: fromDatatype.VarcharDatatypeInterface;
  url_destination: fromDatatype.VarcharDatatypeInterface;
  utm_source: fromDatatype.VarcharDatatypeInterface;
  utm_medium: fromDatatype.VarcharDatatypeInterface;
  utm_term: fromDatatype.VarcharDatatypeInterface;
  utm_content: fromDatatype.VarcharDatatypeInterface;
  click_no_total: fromDatatype.IntegerDatatypeInterface;
  click_no_unique: fromDatatype.IntegerDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
}
